import React, {useState} from "react";
import {useLanguage} from "../../../LanguageContext";

import {menuStyle, scrollButtonStyle, tabIndicatorStyles, tabName, tabStyle} from "../../styles/TripDetailsStyles";
import {Box, Tab, Tabs, Typography} from "@mui/material";


const TabsSection = ({tabs}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const {t} = useLanguage();

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const min = tabs.length === 5 ? '20%' : '25%';
    const renderTabContent = () => {
        if (tabs.length === 5) {
            switch (selectedTab) {
                case 0:
                    return tabs[0];
                case 1:
                    return tabs[1];
                case 2:
                    return tabs[2];
                case 3:
                    return tabs[3];
                case 4:
                    return tabs[4];
                default:
                    return null;
            }
        } else {
            switch (selectedTab) {
                case 0:
                    return tabs[0];
                case 1:
                    return tabs[1];
                case 2:
                    return tabs[2];
                case 3:
                    return tabs[3];
                default:
                    return null;
            }
        }
    };

    return (
        <Box sx={{
            paddingTop: '8px',
            backgroundColor: "#29362C",
        }}>
            <Box sx={{display: 'flex', width: '100%',}}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    TabIndicatorProps={tabIndicatorStyles}
                    sx={menuStyle}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    TabScrollButtonProps={scrollButtonStyle}
                >
                    <Tab
                        sx={tabStyle(min)}
                        label={<Typography sx={tabName}>
                            {t('label_trip')}</Typography>}/>
                    <Tab
                        sx={tabStyle(min)}
                        label={<Typography sx={tabName}>{t('label_program')}</Typography>}/>
                    <Tab
                        sx={tabStyle(min)}
                        label={<Typography sx={tabName}>{t('label_hotel')}</Typography>}/>
                    <Tab
                        sx={tabStyle(min)}
                        label={<Typography sx={tabName}>{t('label_price')}</Typography>}/>
                    {tabs[4] && <Tab
                        sx={tabStyle(min)}
                        label={<Typography sx={tabName}>{t('label_essential')}</Typography>}/>}
                </Tabs>
            </Box>

            <Box>
                {renderTabContent()}
            </Box>
        </Box>
    )
}

export default TabsSection;

